exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".featured {\n  position: relative;\n  overflow: hidden;\n}\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./client/app/components/home/home.less
 ** module id = 64
 ** module chunks = 0
 **/